import React, { Component } from 'react';
import PageHeader from 'components/enterprise/PageHeader';
import _validator from 'modules/validator';
import _HelpDeskAdminServices from '../../modules/HelpDeskAdminService';
import _notification from 'modules/notification';
import { Card } from 'antd';
import { GENERAL_ERROR_MESSAGE } from 'constants/constants';
import FileUpload from '../../components/controls/FileUpload';
import ButtonComponent from 'components/controls/Button';
import xls from '../../assets/template/TransactionsList.xlsx';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';

import {
    SESSION_TOKEN,
    USER_ROLE,
} from 'constants/constants';

class UploadTransactionsData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            uploadedDoc: "",
            fileError: "",
            loading: false,
            uploadErrorMessage: ""
        };
    }

    handleUpload = async (input) => {
        if (this.state.uploadedDoc && this.state.fileError == "") {
            try {
                this.setState({ loading: true }, async () => {
                    try {
                        var formData = new FormData()
                        formData.append('file', this.state.uploadedDoc)

                        //console.log("Form data: ", formData);

                        const response = await _HelpDeskAdminServices.ImportOnlineTransactionsData(formData);
                        
                        // console.log( "response++++",response);
                        if (response.data.IsSuccess) {
                            _notification.showMessage('success', "File uploaded successfully.");
                            this.setState({
                                uploadedDoc: "",
                                fileError: "",
                                loading: false,
                            });
                        }
                        else {
                            // _notification.showMessage('error', response.data.Message);
                            let responseMessage = response.data.Message;
                            this.setState({
                                loading: false,
                                uploadErrorMessage : responseMessage
                            });

                            if (responseMessage == "" || responseMessage == null || responseMessage == undefined) {
                                _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                            }
                        }
                    } catch (e) {
                        // TODO
                        this.setState({ loading: false });
                        console.log('Error: ', e);
                        _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                    }
                });
            } catch (e) { }
        } else {
            _notification.showMessage('error', "Select file to upload");
        }
    }

    onFileDrop = (file) => {
        //console.log(file);
        this.setState({ uploadedDoc: file, fileError: '', uploadErrorMessage: "" });
    }

    onFileError = (errorMsg) => {
        console.log(errorMsg);
        this.setState({ fileError: errorMsg })
    }

    render() {

        if (this.state.loading)
            return <LoadingSpinner/>


        console.log("UserROle", localStorage[USER_ROLE])
        console.log("Token", localStorage[SESSION_TOKEN])


        return (

            <div className="container-fluid p-3">
                <PageHeader
                    title="Upload Transactions Data"
                    breadcrumbItems={[{ label: 'HelpDesk Admin' }, { label: 'Upload Transactions Data' }]}
                />
                <div className="max1200 m-auto">
                    <div className="ent-panel">
                        <h4 className="heading4">Upload Online Transactions </h4>
                        <div className="admin-inner-wrap p-3">  
                            
                            <div className="mb-2 col-sm-12 uploadCard">
                                <FileUpload onFileDrop={this.onFileDrop} onError={this.onFileError} />
                                {this.state.fileError ? <label className="textAlignCenter  " htmlFor="password"><span className="color-red">Error: {this.state.fileError}</span></label> : <></>}
                            </div>
                            {this.state.uploadErrorMessage != "" ?
                                    <Card className="mb-2 col-sm-12 pb-3 uploadErrorMsgAlign">
                                        {this.state.uploadErrorMessage != "" ?
                                            <span className='color-red' dangerouslySetInnerHTML={{ __html: this.state.uploadErrorMessage }}></span> :
                                            <></>}
                                    </Card>
                                    :
                                    <></>
                                }
                        </div>
                        <div className="pt-4 buttonAlignCenter" >
                            <ButtonComponent type="button" value="Upload File" onClick={this.handleUpload} className="button-global button-primary autoHeight small" disabled={this.state.uploadErrorMessage != "" || this.state.loading} />
                        </div>
                    </div>
                </div>
            </div>

        )
    };
}

export default UploadTransactionsData;